<template>
	<div class="md-layout">
		<div class="md-layout-item">
			<md-card class="card-table">
				<md-card-header class="md-card-header-icon md-card-header-blue">
					<div class="md-layout">
						<div class="md-layout-item">
							<div class="card-icon">
								<md-icon>bug_report</md-icon>
							</div>
							<h4 class="title">Liste des insectes</h4>
						</div>
						<div class="md-layout-actions md-layout-item md-size-40 text-right align-center mt-3">
							<div class="flex items-center">
								<div>
									<md-button class="md-info md-sm md-button-action"
										@click="goToRoute('Add Insect')">
										<md-icon class="material-icons mr-1">add</md-icon>
										<span>Ajouter un insecte</span>
									</md-button>
								</div>
							</div>
						</div>
					</div>
				</md-card-header>
				<md-card-content class="mt-2">
					<md-table v-model="insects" table-header-color="blue">
						<md-table-row slot="md-table-row" slot-scope="{ item }">
							<md-table-cell md-label="Nom"><span>{{ item.name }}</span></md-table-cell>
							<md-table-cell md-label="État">
								<span :class="item.is_active ? 'text-success' : 'text-danger'">
									{{ isActive(item.is_active) }}
								</span>
							</md-table-cell>
							<md-table-cell md-label="" style="min-width: 75px">
								<div class="w-full flex items-center justify-end">
									<div class="mr-2">
										<md-button class="md-icon-button md-raised" :class="item.path ? 'md-info' : 'md-default'" :disabled="!item.path"
											:href="item.path ? item.url : null" target="_blank">
											<i class="md-icon fa fa-image"/>
										</md-button>
										<md-tooltip md-direction="top">
											<span v-if="item.path">Voir la photo</span>
											<span v-else>Aucune photo disponible</span>
										</md-tooltip>
									</div>
									<div class="mr-2">
										<md-button class="md-icon-button md-raised md-warning"
											@click="goToRoute('Edit Insect', item.id)">
											<i class="md-icon fa fa-pen"/>
										</md-button>
										<md-tooltip md-direction="top">Modifier</md-tooltip>
									</div>
								</div>
							</md-table-cell>
						</md-table-row>
					</md-table>
				</md-card-content>
			</md-card>
		</div>
	</div>
</template>

<script>
export default {
	name: "Insects",
	data() {
		return {
			insects: []
		}
	},
	methods: {
		goToRoute(route, id = null) {
			this.$router.push({ name: route, params: { id }})
		},
		isActive(boolean) {
			return boolean ? 'Actif' : 'Désactivé'
		},
		async getInsects() {
			let { data } = await this.$store.dispatch('insects/getInsects', {})
			this.insects = data
		}
	},
	mounted() {
		this.getInsects()
	}
}
</script>

<style scoped>

</style>
